import api from './api'

const API = '/api/client/bookings'

export const Booking = {
  getRoutes: function(params) {
    return api.get(`${API}/available-routes`, {params: params}) 
  },
  getTrips: function(params) {
    return api.get(`${API}/available-trips`, {params: params}) 
  },
  getMessages: function(id, params) {
    return api.get(`${API}/${id}/messages`, {params: params}) 
  },
  downloadManifest: function(id, params) {
    return api.get(`${API}/${id}/download-manifest`, {params: params}) 
  },
  downloadContactNumbers: function(id, params) {
    return api.get(`${API}/${id}/download-contact-numbers`, {params: params}) 
  },
  allowOnline: function(id, params) {
    return api.update(`${API}/${id}/allow-online`, params) 
  },
  updateStatus: function(id, params) {
    return api.update(`${API}/${id}/update-status`, params) 
  },
  changeVessel: function(id, form) {
    return api.update(`${API}/${id}/change-vessel`, form)
  },
  sendMessage: function(id, form) {
    return api.update(`${API}/${id}/send-message`, form)
  },
  saveExtraSeats: function(id, form) {
    return api.update(`${API}/${id}/save-extra-seats`, form)
  },
  transferPassengers: function (id, form) {
    return api.update(`${API}/${id}/transfer-passengers`, form) 
  },
  getTakenSeats: function(id, params) {
    return api.get(`${API}/${id}/taken-seats`, {params: params}) 
  },
  getBooking: function(params) {
    return api.get(`${API}/available-booking`, {params: params}) 
  },
  get: function(params) {
    return api.get(API, params)
  },
  show: function(id, params) {
    return api.get(API + '/' + id, params)
  },
  create: function(params) {
    return api.create(API, params)
  },
  disable: function(id, form) {
    return api.update(API+'/'+id+'/disable', form)
  },
  setNoShowBySeatNumber: function(id, form){
    return api.update(API+'/'+id+'/set-non-show-by-seat-number', form)
  },
  update: function(params) {
    return api.update(API+'/'+params.id, params)
  },
  delete: function(params) {
    return api.delete(API+'/'+params.id, params)
  }
}